import DatePickers from './DatePickers/DatePickers'
import DynamicDates from './DynamicDates/DynamicDates'
import useDateRangeFilter from './hooks/useDateRangeFilter'
import TypeSelector from './TypeSelector/TypeSelector'
import { rangeTypes } from './constants'
import * as Styles from './styles'

const DateRangeFilter = ({
  label,
  onChangeRange,
  value,
  onChangeDaysGte,
  onChangeDaysLte,
  disabledType,
  showTypeSelector,
}) => {
  const onChangeFunctions = {
    gte: onChangeDaysGte,
    lte: onChangeDaysLte,
  }

  const {
    rangeType,
    setRangeType,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dynamicType,
    setDynamicType,
    dynamicValue,
    setDynamicValue,
  } = useDateRangeFilter({
    range: value?.rangeValue,
    dynamic: value?.dynamicValue,
  })

  const handleDatesChange = ({ startDate, endDate }) => {
    if (onChangeRange) {
      onChangeRange({ startDate: startDate?.format('YYYY-MM-DD'), endDate: endDate?.format('YYYY-MM-DD') })
    }
  }

  const handleStartDateChange = date => {
    setStartDate(date)
    date?.isValid() && handleDatesChange({ startDate: date, endDate })
  }

  const handleEndDateChange = date => {
    setEndDate(date)
    date?.isValid() && handleDatesChange({ startDate, endDate: date })
  }

  const handleChangeDynamicValue = e => {
    setDynamicValue(e.target.value)

    const newValue = Number(e.target.value)

    if (!newValue) {
      onChangeFunctions[dynamicType](null)
    } else {
      if (Number.isInteger(newValue)) {
        onChangeFunctions[dynamicType](newValue)
      }
    }
  }

  const handleChangeDynamicType = e => {
    const dynamicType = e.target.value

    setDynamicType(dynamicType)
    onChangeDaysGte(null)
    onChangeDaysLte(null)

    onChangeFunctions[dynamicType](Number(dynamicValue))
  }

  const handleChangeRangeType = type => {
    setRangeType(type)

    if (type === rangeTypes.fixed) {
      onChangeDaysGte(null)
      onChangeDaysLte(null)
    } else {
      onChangeRange({ startDate: null, endDate: null })
    }
  }

  return (
    <div>
      <Styles.Label>{label}</Styles.Label>
      <Styles.Container>
        {showTypeSelector && (
          <TypeSelector value={rangeType} onChange={handleChangeRangeType} disabled={disabledType} />
        )}
        {rangeType === rangeTypes.fixed && (
          <DatePickers
            value={{ startDate, endDate }}
            onChangeStartDate={handleStartDateChange}
            onChangeEndDate={handleEndDateChange}
          />
        )}
        {rangeType === rangeTypes.dynamic && (
          <DynamicDates
            value={dynamicValue}
            onChangeValue={handleChangeDynamicValue}
            onChangeType={handleChangeDynamicType}
            type={dynamicType}
          />
        )}
      </Styles.Container>
    </div>
  )
}

export default DateRangeFilter
